import { createFileRoute } from "@tanstack/react-router"

import { HomeApplicationsCard } from "@/components/lender/HomeApplicationsCard"
import { HomeReferralsCard } from "@/components/lender/HomeReferralsCard"
import { HomeSupportCard } from "@/components/lender/HomeSupportCard"
import { HomeUsersCard } from "@/components/lender/HomeUsersCard"

export const Route = createFileRoute("/_dashboard/lender/home")({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 [&>*]:min-w-0">
      <HomeApplicationsCard />
      <HomeReferralsCard />
      <HomeSupportCard />
      <HomeUsersCard />
    </div>
  )
}
